<!-- @veltra/icons generated sha256:5498e59c9df47b92 gen:8 source:src/svg/normal/minus.svg -->
<script setup lang="ts">
defineOptions({ name: 'Minus' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path d="M5 12h14" />
  </svg>
</template>
